import * as angular from 'angular';

export const PrestoPortValidatorDirective = function () {
  return {
    scope: {},
    require: 'ngModel',
    link: function (scope, elm, attrs, ngModel) {
      ngModel.$validators.verify_presto_port = function (modelValue, viewValue) {
        if (ngModel.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        } else if (443 == viewValue || 1024 <= viewValue) {
          return true;
        } else {
          return false;
        }
      };
    },
  };
};

angular.module('mode.components').directive('prestoPortValidator', PrestoPortValidatorDirective);
